import React from 'react'
import styles from './PaneTitle.module.scss'
import { Icon, ArchiveIcon } from 'components/shared/Icon/Icon'

export const PaneTitle = ({ label, active }) => (
  <span className={styles.title}>
    {label}
    {!active ? (
      <Icon
        title="archived job"
        className={styles.icon}
        icon={ArchiveIcon}
        size={19}
      />
    ) : null}
  </span>
)
